import { deploymentService } from "fleet/service/deployment";
import { createApiSaga } from "redux-store/api-sagas";

import {
  DELETE_SCHEDULED_DEPLOYMENT,
  DELETE_SCHEDULED_DEPLOYMENT_SUCCESS,
  EDIT_SCHEDULED_DEPLOYMENT,
  EDIT_SCHEDULED_DEPLOYMENT_SUCCESS,
  LOAD_SCHEDULED_DEPLOYMENTS,
  LOAD_SCHEDULED_DEPLOYMENTS_SUCCESS,
  SCHEDULE_DEPLOYMENT,
  SCHEDULE_DEPLOYMENT_SUCCESS,
} from "./actions";

const deleteScheduledDeploymentSaga = createApiSaga({
  fetchAction: DELETE_SCHEDULED_DEPLOYMENT,
  successAction: DELETE_SCHEDULED_DEPLOYMENT_SUCCESS,
  service: deploymentService.delete,
  serviceName: "deploymentService.delete",
  reload: false,
});

const editScheduledDeploymentSaga = createApiSaga({
  fetchAction: EDIT_SCHEDULED_DEPLOYMENT,
  successAction: EDIT_SCHEDULED_DEPLOYMENT_SUCCESS,
  service: deploymentService.edit,
  serviceName: "deploymentService.edit",
  reload: false,
});

const loadScheduledDeploymentsSaga = createApiSaga({
  fetchAction: LOAD_SCHEDULED_DEPLOYMENTS,
  successAction: LOAD_SCHEDULED_DEPLOYMENTS_SUCCESS,
  service: deploymentService.loadScheduled,
  serviceName: "deploymentService.loadScheduled",
  reload: false,
});

const scheduleDeploymentSaga = createApiSaga({
  fetchAction: SCHEDULE_DEPLOYMENT,
  successAction: SCHEDULE_DEPLOYMENT_SUCCESS,
  service: deploymentService.schedule,
  serviceName: "deploymentService.schedule",
  reload: false,
});

const scheduledDeploymentsSagas = [
  deleteScheduledDeploymentSaga(),
  editScheduledDeploymentSaga(),
  loadScheduledDeploymentsSaga(),
  scheduleDeploymentSaga(),
];

export { scheduledDeploymentsSagas };
